enum LoadingAreaEnum {
  PAGE = "PAGE",
  EXCHANGE = "EXCHANGE",
  BOOKMAKER = "BOOKMAKER",
  FANCYBET = "FANCYBET",
  MINI_GAME = "MINI_GAME",
  SPORTSBOOK = "SPORTSBOOK",
  GENIUSSPORTS = "GENIUSSPORTS",
  WALLET = "WALLET",
  OPEN_BET = "OPEN_BET"
}

export type LoadingArea = keyof typeof LoadingAreaEnum

export const useLoadingStore = defineStore("loading", () => {
  const initialEntries: { [k in LoadingArea]: number } = {
    [LoadingAreaEnum.PAGE]: 0,
    [LoadingAreaEnum.EXCHANGE]: 0,
    [LoadingAreaEnum.MINI_GAME]: 0,
    [LoadingAreaEnum.WALLET]: 0,
    [LoadingAreaEnum.OPEN_BET]: 0,
    [LoadingAreaEnum.BOOKMAKER]: 0,
    [LoadingAreaEnum.FANCYBET]: 0,
    [LoadingAreaEnum.SPORTSBOOK]: 0,
    [LoadingAreaEnum.GENIUSSPORTS]: 0
  }

  const mapCount = ref(new Map(Object.entries(initialEntries)))

  const reset = (target: LoadingArea) => {
    mapCount.value.set(target, 0)
  }

  const accumulate = (target: LoadingArea, value: number) => {
    mapCount.value.set(target, (mapCount.value.get(target) || 0) + value)
  }

  const load = (target: LoadingArea) => accumulate(target, 1)
  const unload = (target: LoadingArea) => accumulate(target, -1)

  return {
    mapCount,
    load,
    unload,
    reset
  }
})

export default useLoadingStore
